import {
  IModifiedData,
  IStandardPredictionFilter,
  IStandardPredictionPostRequest,
} from '../../core/interfaces/standard-prediction.interface';
import {
  IGetFiltersRequest,
  IGetFiltersSemanaSantaRequest,
  IGetEstacionalRequest,
} from '../../core/interfaces/estacional-prediction.interface';

export type PredictionType = 'holyweek' | 'recessweek' | 'endyear' | 'vacation';

export class GetSeasonalPredictionFilters {
  static readonly type =
    '[EstacionalPrediction] Get Seasonal Prediction Filters';
  constructor() {}
}

export class UpdateModifiedDataSeasonal {
  static readonly type = '[EstacionalPrediction] Update Modified Data';
  constructor(public payload: IModifiedData) {}
}

export class GetSeasonalPredictionEdit {
  static readonly type = '[EstacionalPrediction] Get Seasonal Prediction Edit';
  constructor(
    public payload: IGetFiltersRequest,
    public predictionType: PredictionType
  ) {}
}

export class GetSeasonalPredictionEditSemanaSanta {
  static readonly type =
    '[EstacionalPrediction] Get Seasonal Prediction Edit Semana Santa';
  constructor(public payload: IGetFiltersSemanaSantaRequest) {}
}

export class GetSeasonalPredictionTemporal {
  static readonly type =
    '[EstacionalPrediction] Get Seasonal Prediction Temporal';
  constructor(public payload: string) {}
}

export class GetGenerationSeasonalPredictionTemporal {
  static readonly type =
    '[EstacionalPrediction] Get Generation Seasonal Prediction Temporal';
  constructor(public payload: string) {}
}

export class ApplyPredictionPercentagesSeasonal {
  static readonly type = '[EstacionalPrediction] Apply Prediction Percentages';
}

export class PostGenerateSeasonalPrediction {
  static readonly type =
    '[EstacionalPrediction] Post Generate Seasonal Prediction';
  constructor(
    public payload: IStandardPredictionPostRequest,
    public predictionType: PredictionType
  ) {}
}

export class PostGenerateSeasonalSemanaSanta {
  static readonly type =
    '[EstacionalPrediction] Post Generate Seasonal Semana Santa';
  constructor(
    public payload: IStandardPredictionPostRequest,
    public predictionType: PredictionType
  ) {}
}

export class GetSeasonalPredictionGenerate {
  static readonly type =
    '[EstacionalPrediction] Get Seasonal Prediction Generate';
  constructor(public payload: string) {}
}

export class GetEstacionalPrediction {
  static readonly type = '[EstacionalPrediction] Get Estacional Prediction';
  constructor(public payload: IGetEstacionalRequest) {}
}

export class SetCurrentFiltersSeasonal {
  static readonly type = '[EstacionalPrediction] Set Current Filters';
  constructor(public payload: any) {}
}
export class SetSelectedSeasonalDate {
  static readonly type = '[EstacionalPrediction] Set Selected Seasonal Date';
  constructor(public payload: string) {}
}

export class SetActualBaseEstacional {
  static readonly type = '[EstacionalPrediction] Set Actual Base Estacional';
  constructor(public payload: string) {}
}

export class SetSelectedTabHome {
  static readonly type = '[EstacionalPrediction] Set Selected Tab Home';
  constructor(public payload: number) {}
}
